export const pricingPlans = [
  {
    name: 'Starter',
    price: 'Free forever',
    description: 'Hiring your first few people',
    features: [
      '1 active role',
      'Up to 50 candidates per role',
      'Ingesting resumes and portfolios',
      'AI summaries and structured scorecards',
      'Clear decision recommendations',
    ],
    cta: 'Get Started',
    href: '/signup',
    highlighted: false,
  },
  {
    name: 'Team',
    price: '$129/month',
    description: 'Interviews are starting to add up, opinions don\'t always align, and speed vs quality keeps you up at night.',
    features: [
      'Everything in Starter, plus:',
      'Up to 3 active roles',
      'AI powered screening',
      'Basic ATS integrations',
    ],
    cta: 'Get Started',
    href: '/signup',
    highlighted: true,
  },
  {
    name: 'Pro',
    price: '$249/month',
    description: 'Level calibration starts to matter, interview scheduling becomes a bottleneck, and decisions need to be explainable later.',
    features: [
      'Everything in Team, plus:',
      'Up to 10 active roles',
      'AI powered scheduling',
      'Level-indexed evaluation and scoring',
      'AI interviews, case studies, and live coding evaluations',
      'SSO and data residency options',
      'Advanced ATS integrations',
    ],
    cta: 'Get Started',
    href: '/signup',
    highlighted: false,
  },
  {
    name: 'Enterprise',
    price: 'Starting at $999/month',
    description: 'For recruiting firms and large organizations with complex needs.',
    features: [
      'Everything in Team, plus:',
      'Up to 100 active roles',
      'Support for many roles and clients',
      'Client data isolation',
      'White labeling',
      'Custom AI evaluations and workflows',
      'Dedicated account management',
    ],
    cta: 'Get Started',
    href: '/signup',
    highlighted: false,
  },
]


export function PricingGrid() {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
      {pricingPlans.map((plan) => (
        <div
          key={plan.name}
          className={`card p-6 flex flex-col ${
            plan.highlighted
              ? 'ring-2 ring-brand-500 shadow-lg'
              : ''
          }`}
        >
          <div className="mb-6">
            <h3 className="text-xl font-bold text-surface-900 mb-1">{plan.name}</h3>
            <p className="text-lg font-semibold text-brand-600 mb-4">{plan.price}</p>
            <p className="text-sm text-surface-600 mb-4">{plan.description}</p>
          </div>

          <div className="border-t border-surface-200 pt-6 mb-6 flex-1">
            <p className="text-xs font-semibold text-surface-500 uppercase tracking-wide mb-3">
              Includes
            </p>
            <ul className="space-y-2">
              {plan.features.map((feature) => (
                <li key={feature} className="flex items-start gap-2 text-sm text-surface-600">
                  <svg className="w-4 h-4 text-brand-500 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          <a
            href={plan.href}
            className={`btn text-center ${
              plan.highlighted
                ? 'bg-brand-600 text-white hover:bg-brand-700'
                : 'bg-surface-100 text-surface-900 hover:bg-surface-200'
            }`}
          >
            {plan.cta}
          </a>
        </div>
      ))}
    </div>
  )
}

